export const LinkMenu = {
  Draft: {
    name: 'navigatedraft',
    text: 'Navigate to draft',
    icon: 'hyperlink-open'
  },
  Download: {
    name: 'draftdownload',
    text: 'Download draft zip',
    icon: 'download'
  },
  DatasetInfo: {
    name: 'draftdatasetinfo',
    text: 'Dataset Name',
    icon: 'copy'
  },
  Import: {
    name: 'draftimport',
    text: 'Import Pbix',
    icon: 'upload'
  },
  Dataset: {
    name: 'navigatedataset',
    text: 'Navigate to dataset workspace',
    icon: 'hyperlink-open'
  },
  Version: {
    name: 'navigateversion',
    text: 'Navigate to version workspace',
    icon: 'hyperlink-open'
  }
};
